import styled from 'styled-components';

import { Col, Row } from '@components/formStyles';

export const StyledRow = styled(Row)`
  cursor: pointer;
  & img {
    object-fit: cover;
  }
`;

export const MainImageWrapper = styled.div`
  position: relative;
  & img {
    border-radius: 8px;
  }
`;

export const CertificateWrapper = styled.div`
  width: 100%;
  height: 40px;
  line-height: 40px;
`;

type CheckmarkIconWrapperProps = {
  top?: `${number}px`;
  right?: `${number}px`;
};
export const CheckmarkIconWrapper = styled.div<CheckmarkIconWrapperProps>`
  position: absolute;
  left: ${(p) => p.right ?? '30px'};
  top: ${(p) => p.top ?? '30px'};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    left: ${(p) => p.right ?? '20px'};
    top: ${(p) => p.top ?? '10px'};
  }
  display: flex;
  gap: 30px;
  z-index: 1;
`;
export const VideoIcon = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    right: 20px;
    top: 10px;
  }
  display: flex;
  gap: 30px;
  z-index: 1;
`;

export const StyledCol = styled(Col)`
  margin-left: 15px;
  & img {
    border-radius: 8px;
  }
`;

export const LastImage = styled.div`
  margin-top: 15px;
`;

export const ViewGalleryButton = styled.button`
  position: absolute;
  border-style: none;
  bottom: 110px;
  color: ${(p) => p.theme.palette.white};
  font-weight: bold;
  font-size: 18px;
  margin-left: 30px;
  background: ${(p) => p.theme.palette.eclipse};
  border-radius: 8px;
  cursor: pointer;
  padding: 10px 20px;
  height: 42px;
  display: flex;
  align-items: center;
  ${(p) => p.theme.mediaQueries.GALLERY_SMALL_SCREEN} {
    display: none;
  }
`;
